// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RedirectPage{display:flex}", "",{"version":3,"sources":["webpack://./a-portal/pages/RedirectPage/index.sass"],"names":[],"mappings":"AAAA,cACE,YAAA","sourcesContent":[".RedirectPage\n  display: flex\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
